import { UseMutationOptions, UseQueryOptions } from "@tanstack/react-query";
import { useAuthQuery, useAuthMutation } from "@rentablo/api";
import { downloadInvoice, getInvoices } from "@api/v1/methods";
import { InvoiceList } from "@api/v1/model";

import { MY_INVOICES } from "../../cacheKeys";

export const useMyInvoices = (
  options?: UseQueryOptions<InvoiceList, AxiosApiError, InvoiceList>
) => useAuthQuery([MY_INVOICES], ({ token }) => getInvoices(token), options);

export const useDownloadInvoice = (
  options?: UseMutationOptions<
    { data: Blob; name: string },
    AxiosApiError,
    number
  >
) => useAuthMutation(downloadInvoice, options);
